<template>
  <div class="block_1_ flex-row" style="position: relative;">
    <span class="text_1">{{ labelText }}</span>
    <div class="block_2 flex-row">
      <span class="text_2">{{ duration }}</span>
      <el-dropdown @command="handleCommand" trigger="click">
        <el-button style="height: 34px;width: 58px;position: relative;left:45px;border:none;">
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1小时">1小时</el-dropdown-item>
          <el-dropdown-item command="半小时">半小时</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    labelText: {
      type: String,
      required: true,
    },
    selections: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      duration: '',
    };
  },
  methods: {
    handleCommand(command) {
      //this.$message(`你选择了: ${command}`)
      this.duration = command
    }
  },
};
</script>
<style scoped lang="css" src="./assets/index.css" />